// Import Libraries
import React from 'react';
import PropTypes from 'prop-types';
// Import JS Modules
import Store from '../_utils/tools/store';

// -----------------------------------------------------------
//  TaxesAndDeliveryPrompt
// -----------------------------------------------------------

const TaxesAndDeliveryPrompt = ({ us, row }, { taxesAndDeliveryPrompt }) => {
  if (taxesAndDeliveryPrompt) {
    return (
      <small data-test-id="prompt-note" dangerouslySetInnerHTML={{ __html: taxesAndDeliveryPrompt }} />
    );
  }

  return <small>{Store.isUnitedStates() ? us : row}</small>;
};

// -----------------------------------------------------------

TaxesAndDeliveryPrompt.propTypes = {
  us: PropTypes.string.isRequired,
  row: PropTypes.string.isRequired,
};

TaxesAndDeliveryPrompt.contextTypes = {
  taxesAndDeliveryPrompt: PropTypes.string,
};

// -----------------------------------------------------------

export default TaxesAndDeliveryPrompt;
